import type { FC } from 'react'

import Image from '@segment/matcha/components/Image'
import Elevation from '@segment/matcha/components/Elevation'

import SyncDataPng2x from './assets/SyncData@2x.png'
import SyncDataWebp from './assets/SyncData.webp'
import SyncDataWebp2x from './assets/SyncData@2x.webp'

interface SyncDataImageProps {
  alt: string
}

const SyncDataImage: FC<SyncDataImageProps> = ({ alt }) => {
  return (
    <Elevation elevation={2} type="dropShadow">
      <picture>
        <source type="image/webp" srcSet={`${SyncDataWebp}, ${SyncDataWebp2x} 2x`} />
        <Image width="710" height="442" src={SyncDataPng2x} alt={alt} loading="lazy" />
      </picture>
    </Elevation>
  )
}

export default SyncDataImage
